// src/components/ServicesPage.jsx
import { LuLayers } from "react-icons/lu";
import Services from "./Service";

//import Link
import { Link } from "react-router-dom";

const ServicesPage = () => {
  return (
    <section className="pt-32 pb-20 bg-[#f8f3ec]">
      <div className="container mx-auto px-6">
        {/* Outer Card Wrapper Similar to ServiceDetail */}
        <div className="bg-white rounded-3xl shadow-[0_8px_30px_rgba(0,0,0,0.08)] border border-accent/20 p-10 md:p-14">
          {/* Services Page Heading */}
          <div className="text-center mb-10">
            <div className="flex justify-center mb-4">
              <LuLayers className="text-accent text-6xl" />
            </div>

            <h1 className="text-4xl md:text-5xl font-primary font-bold text-primary mb-4">
              Our Legal Services
            </h1>

            <p className="text-gray-700 max-w-2xl mx-auto text-lg leading-relaxed">
              Explore our legal offerings designed to support entrepreneurs,
              athletes, creators, and individuals navigating business, brand
              protection, personal injury, and NIL matters.
            </p>
          </div>
          {/* Actual Services Grid */}
          <div className="mt-6">
            <Services />
          </div>
          {/* Back to home */}
          <div className="mb-6">
            <Link
              to="/"
              className="inline-flex items-center text-primary hover:text-accent font-semibold transition-colors duration-200"
            >
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesPage;
